module.exports = __webpack_public_path__ + "static/media/ic-excluir.4b2dd1ae.svg";